import React from 'react'
import PropTypes from 'prop-types'

import PlaceholderImage from '../../placeholder-image';
import { Paragraph } from '../../typography';

import {
  Avatar,
  BottomWrapper,
  Image,
  LinkWrapper,
  Wrapper,
  TextWrapper,
} from './social-card.styles'

const SocialCard = ({
  authorHandle,
  authorName,
  authorPhotoUrl,
  photoUrl,
  url,
  backgroundColor,
}) => {
  const placeholder = <PlaceholderImage alt={authorHandle} width={250} height={250} />;;

  return (
    <Wrapper>
      <LinkWrapper url={url}>
        <Image
          height={250}
          width={250}
          quality={70}
          offset={500}
          placeholder={placeholder}
          src={`${photoUrl}?w=250&h=250&fm=jpg`} 
          imageProps={{draggable: 'false'}}
        />
        <BottomWrapper backgroundColor={backgroundColor}>
          <Avatar src={`${authorPhotoUrl}?w=50&h=50&fm=jpg`} imageProps={{draggable: 'false'}}/>
          <TextWrapper>
            <Paragraph>{authorName}</Paragraph>
            <Paragraph>{authorHandle}</Paragraph>
          </TextWrapper>
        </BottomWrapper>
      </LinkWrapper>
    </Wrapper>
  )
}

SocialCard.propTypes = {
  authorHandle: PropTypes.string.isRequired,
  authorName: PropTypes.string.isRequired,
  authorPhotoUrl: PropTypes.string.isRequired,
  photoUrl: PropTypes.string.isRequired,
  url: PropTypes.string,
  backgroundColor: PropTypes.string,
}

SocialCard.defaultProps = {
  url: null,
  backgroundColor: null
}

export default SocialCard
